import { render } from "./subBrandsSelector.vue?vue&type=template&id=3f279eaa&scoped=true"
import script from "./subBrandsSelector.vue?vue&type=script&lang=js"
export * from "./subBrandsSelector.vue?vue&type=script&lang=js"

import "./subBrandsSelector.vue?vue&type=style&index=0&id=3f279eaa&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f279eaa"]])

export default __exports__